



















  import { defineComponent, ref, Ref, computed } from 'vue'
  import { Account } from '@one/types'
  import { PaymentMethodType } from '@one/types/dist/orderpath/app/shared'
  import useCurrentInstance from '~/utils/useCurrentInstance'
  import { priceFormatter } from '~/utils/filters'
  import usePaymentsUtils from '~/composables/usePaymentsUtils'

  export default defineComponent({
    name: 'OneExternalPaymentLimitsBanner',
    setup() {
      const vm = useCurrentInstance()
      const { leaselinkLogo } = usePaymentsUtils(vm)
      const clientLimits: Ref<Account.App.Responses.ExternalPaymentLimitsDto | undefined> = ref()

      const availableLimits = computed(() => clientLimits.value?.limits)
      const hasLimits = computed(() => clientLimits.value?.limits?.length)
      const currency = computed(() => vm.$store.getters['layout/getCurrency'])

      const fetchExternalPaymentLimits = () =>
        vm.$store.dispatch('account/fetchExternalPaymentLimits')

      const limitLabel = (type: PaymentMethodType): any => {
        switch (type) {
        case PaymentMethodType.LEASELINK:
          return 'client.account.external_payment_limits.leaselink'
        default:
          return 'client.account.external_payment_limits'
        }
      }

      const init = async () => {
        try {
          clientLimits.value = await fetchExternalPaymentLimits()
        } catch (e) {
          clientLimits.value = undefined
        }
      }

      init()
      return {
        limitLabel,
        leaselinkLogo,
        hasLimits,
        availableLimits,
        currency,
        priceFormatter,
      }
    },
  })
